// extracted by mini-css-extract-plugin
module.exports = {"section":"h0Rx3","section-content":"OgNCD","images-row":"qjIAo","app-store-img":"_5iOIZ","play-store-img":"fG44q"};